import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { M_Table, DefaultURl, M_Button } from 'src/M_Components'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { Delete } from '@mui/icons-material'

export const UserConfig = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const [isLabel, setIsLabel] = useState(true)
    const navigate = useNavigate()
    const [lineContextMenu, setLineContextMenu] = useState([])
    const [buttons, setButtons] = useState([])
    const [refresh, setRefresh] = useState(false)
    const [deleteDialog, setDeleteDialog] = useState({ open: false, userName: '', isContext: false })

    const NewRoute = (url, label, operation) => {
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            const tempLine = sessionStorage.getItem('lines')
            if (!tempLine) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            sessionStorage.setItem('UserLine', JSON.stringify(JSON.parse(tempLine).pop()))
            sessionStorage.removeItem('lines')
        }
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const newRouteContext = (url, label, operation) => {
        sessionStorage.setItem('operation', operation)
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            const tempLine = sessionStorage.getItem('context')
            if (!tempLine) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            sessionStorage.setItem('UserLine', tempLine)
            sessionStorage.removeItem('context')
        }
        navigate(`${url}`)
        onCreateTab(url, label)
    }



    useEffect(() => {
        getPermissions()
    }, [])

    const getPermissions = (Type) => {
        const nameForRole = 'user config'
        const route = "go/UserConfigCrud"
        const tempPerm = []
        const permLines = []
        const permButtons = []
        roles.forEach((role) => {
            if (role.match(nameForRole)) tempPerm.push(role.split(nameForRole)[1])
        })
        permLines.push({ label: t('view'), icon: 'pi pi-search', command: () => newRouteContext(route, 'View Users', 'View') })
        if (tempPerm.includes('Create')) permButtons.push({ label: t('Add'), element: 'default', source: '/icons/tableIcons/add.svg', command: () => NewRoute(route, 'Create Users', 'Create') })
        if (tempPerm.includes('Edit')) {
            permLines.push({ label: t('Edit'), icon: 'pi pi-pencil', command: () => newRouteContext(route, 'Edit Users', 'Edit') })
            permButtons.push({ label: t('Edit'), element: 'default', source: '/icons/tableIcons/edit.svg', command: () => NewRoute(route, 'Edit Users', 'Edit') })
        }
        if (tempPerm.includes('Delete')) {
            permLines.push({ label: t('Delete'), icon: 'pi pi-trash', command: () => confirmDeleteContext() })
            permButtons.push({ label: t('Delete'), element: 'default', source: '/icons/svgsDaNet/trash-2.svg', style: { filter: 'invert(11%) sepia(68%) saturate(6715%) hue-rotate(359deg) brightness(93%) contrast(115%)' }, command: () => confirmDeleteButton() })
        }
        if (tempPerm.includes('Create')) {
            permLines.push({ label: t('Copy'), icon: 'pi pi-copy', command: () => newRouteContext(route, 'Create Users', 'Copy') })
            permButtons.push({ label: t('Copy'), element: 'default', source: '/icons/tableIcons/copy.svg', command: () => NewRoute(route, 'Create Users', 'Copy') })
        }
        if (Type === 'Context') return permLines
        if (Type === 'Buttons') return permButtons
    }

    const onHide = (e) => {
        setIsLabel(e)
    }

    const getLine = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContext = (e) => {
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('context')
        }
    }

    const confirmDeleteButton = () => {
        let tempLine = sessionStorage.getItem('lines')
        let userName = ''
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            userName = tempLine.length > 1 ? tempLine.length + ' ' + t('users') : tempLine[0]?.UserName || ''
        }
        setDeleteDialog({ open: true, userName: userName, isContext: false })
    }

    const deleteButton = () => {
        const routeName = 'identity/registerextras'
        let tempLine = sessionStorage.getItem('lines')
        console.log('DeleteButton', tempLine)
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            sessionStorage.removeItem('lines')
            let deleteCount = 0
            let errorCount = 0
            tempLine.forEach(role => {
                axios.delete(`${DefaultURl}${routeName}/${role.Id}`).then(response => {
                    console.log(response)
                    deleteCount++
                    if (deleteCount + errorCount === tempLine.length) {
                        setRefresh(true)
                        toastMessages('success', '', t("RemoveLine"))
                    }
                }).catch(error => {
                    console.log(error)
                    errorCount++
                    toastMessages('error', '', t("Error"))
                    if (deleteCount + errorCount === tempLine.length) {
                        setRefresh(true)
                    }
                })
            })

        } else {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
    }
    const confirmDeleteContext = () => {
        let tempLine = sessionStorage.getItem('context')
        let userName = ''
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            userName = tempLine?.UserName || ''
        }
        setDeleteDialog({ open: true, userName: userName, isContext: true })
    }

    const handleCloseDeleteDialog = () => {
        setDeleteDialog({ open: false, userName: '', isContext: false })
    }

    const handleConfirmDelete = () => {
        if (deleteDialog.isContext) {
            deleteContext()
        } else {
            deleteButton()
        }
        handleCloseDeleteDialog()
    }

    const deleteContext = () => {
        const routeName = 'identity/registerextras'
        let tempLine = sessionStorage.getItem('context')
        console.log('DeleteContext', tempLine)
        if (tempLine) {
            tempLine = JSON.parse(tempLine)
            sessionStorage.removeItem('context')
            axios.delete(`${DefaultURl}${routeName}/${tempLine.Id}`).then(response => {
                console.log(response)
                setRefresh(true)
                toastMessages('success', '', t("RemoveLine"))
            }).catch(error => {
                console.log(error)
                toastMessages('error', '', t("Error"))
                setRefresh(true)
            })

        } else {
            toastMessages('error', '', t("SelectedLine"))
            return
        }

    }

    const removeContextItems = ['View', 'Create', 'Copy', 'Edit', 'Print', 'Delete']

    return (
        <>
            <Dialog
                open={deleteDialog.open}
                onClose={handleCloseDeleteDialog}
                maxWidth="sm"
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'var(--color-red)' }}>
                    <Delete sx={{ color: 'var(--color-red)' }} />
                    {t('DeleteConfirmation')}
                </DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: '8px' }}>
                        {deleteDialog.userName ? (
                            <>
                                {t('ConfirmDeleteUser').split('{{userName}}')[0]}
                                <b>{deleteDialog.userName}</b>
                                {t('ConfirmDeleteUser').split('{{userName}}')[1]}
                            </>
                        ) : (
                            t('ConfirmDeleteUser').replace('{{userName}}', '')
                        )}
                    </div>
                </DialogContent>
                <DialogActions sx={{ padding: '16px' }}>
                    <M_Button
                        label={t('Cancel')}
                        onClick={handleCloseDeleteDialog}
                        normal
                        hoverEffect
                        borderColor="black"
                    />
                    <M_Button
                        label={t('Delete')}
                        onClick={handleConfirmDelete}
                        normal
                        hoverEffect
                        backgroundColor="var(--color-red)"
                        labelColor="var(--color-white)"
                    />
                </DialogActions>
            </Dialog>
            <M_Table
                entityName={'listUsers'}
                roleName={'user config'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'User Config'}
                lineContext={getPermissions('Context')}
                extraButtons={getPermissions('Buttons')}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                onPassLine={getLine}
                onPassContext={getContext}
                refresh={refresh}
                setRefresh={setRefresh}
            />
        </>
    )
}
